export default {
  getList: {
    method: 'post',
    url: '/client/area/list'
  },
  create: {
    method: 'post',
    url: '/client/area'
  },
  update: {
    method: 'put',
    url: '/client/area'
  },
  delete: {
    method: 'delete',
    url: '/client/area'
  },
  getHistory: {
    method: 'post',
    url: '/client/area/history/list'
  },
  findAreas: {
    method: 'get',
    url: '/client/area/find?key=KEY'
  }
}
